import React from 'react';
import { FilmPoster } from '../DeliverableGroups';
import { CARD, Reveal } from './WrapUp';
import { canDownload, fileAction, mediaLink } from '../../utils/deliverables';
import { tileState } from '../../utils/clientView';
import { tileLine, type DateMap } from '../../utils/deliverableDates';
import type { Deliverable } from '../../types/portal';

/**
 * BLOCK 3 — EVERYTHING ELSE, SMALL.
 *
 * The series as poster-frame tiles under whatever is leading the page.
 * Tapping one moves it into the lead; nothing navigates, because there is
 * nowhere else to go.
 *
 * THE SEARCH BOX AND THE "NEW" BADGES ARE GONE (8 Oct 2026). Both were
 * built for a page that no longer exists. The box only appeared past twelve
 * items and no Portal project has twelve; the badges were drawn from this
 * browser's own localStorage, so they were blank on a client's phone, blank
 * on their second visit from the office, and wrong whenever two people
 * shared a link.
 *
 * **A DATE IN THEIR PLACE (14 Oct 2026).** *Added 11 October* · *Approved 8
 * October* · *Editing, due 16 November*. It says more than a badge did, it
 * is true for everyone who opens the link, and it needs nothing stored in
 * anybody's browser. A piece with no date simply says what it is doing.
 *
 * EACH TILE CARRIES ITS OWN DOWNLOAD WHILE THE PROJECT IS LIVE. Once it is
 * finished they all move into one section at the end instead — the tiles
 * are for deciding, the end is for keeping.
 *
 * NOT ONE BIG BUTTON: the download is a real link, and a link inside a
 * button is invalid and unclickable.
 */
export function WorkIndex({
  items,
  focusId,
  projectComplete,
  dates,
  onPick
}: {
  items: Deliverable[];
  focusId: string;
  projectComplete: boolean;
  dates?: DateMap;
  onPick: (id: string) => void;
}) {
  const columns = items.length <= 3 ? 'grid-cols-1 sm:grid-cols-3' : items.length === 4 ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4';
  return <div className={`grid gap-5 ${columns}`} data-id="element-260" data-mp="10oi2df8lit13">
      {items.map((item, index) => {
      const active = focusId === item.id;
      const link = mediaLink(item);
      const grab = !projectComplete && canDownload(item.status) && link ? link : '';
      const line = tileLine(tileState(item, active), dates?.get(item.id), item.status);
      return <Reveal key={item.id} delay={index * 0.06} className="h-full" data-id="element-261" data-mp="1ehhinjg7cr9p" data-mpi={index}>
            <div className={CARD} data-id="element-262" data-mp="1jdofmmqmesfi">
              <button type="button" onClick={() => onPick(item.id)} className="block w-full text-left" aria-current={active ? 'true' : undefined} data-id="element-263" data-mp="1jgu0fps7v85f">
                <FilmPoster item={item} active={active} data-id="element-264" data-mp="1xer04v1yvuob" />
                <span className="mt-6 block text-[1.15rem] leading-snug" data-id="element-265" data-mp="1xc4tqyqtbl7o">{item.name}</span>
              </button>
              <div className="mt-auto flex flex-wrap items-baseline gap-x-5 gap-y-1 pt-5" data-id="element-266" data-mp="3v6d78wfzqm6c">
                {line && <span className={`label-sm ${active ? 'font-medium text-ink' : 'text-mute'}`} data-id="element-267" data-mp="3rltagtkp80zv">
                    {line}
                  </span>}
                {grab && <a href={grab} target="_blank" rel="noopener noreferrer" className="label-sm text-graphite no-underline transition-colors duration-150 ease-out hover:text-ink" data-id="element-268" data-mp="3hw072fupms6p">
                    {fileAction(item)}
                  </a>}
              </div>
            </div>
          </Reveal>;
    })}
    </div>;
}